import React, { useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import OfferDataSection from "./OfferDataSection";
import { useMaterialUIController, setDirection } from "context";
export default function Offers() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setDirection(dispatch, "rtl");
    return () => setDirection(dispatch, "ltr");
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <OfferDataSection />
      {/* يمكن إضافة باقي أقسام الصفحة هنا */}
    </DashboardLayout>
  );
}
